module.exports = __webpack_public_path__ + "media/06.bdc26e4a.mp3";